// extracted by mini-css-extract-plugin
export default {"main_wrapper":"MainHeader_main_wrapper__xtxYC","main_header":"MainHeader_main_header__FixBh","cart-wd-wrap":"MainHeader_cart-wd-wrap__EBOE9"};